import { useEffect } from 'react';

// 📱 把 visualViewport 的真实高度写进 CSS 变量 --app-vh，供根容器锁定高度用。
//   iPad Chrome 键盘弹出时 dvh/100% 不收缩(键盘覆盖在内容上)→ 内容溢出可滚、拖 logo 窜位、
//   收起留间隙错位。这里用 JS 直接读 visualViewport.height(真实可视高度)硬锁容器高度，
//   键盘进出即时跟随，不依赖浏览器对视口单位/interactive-widget 的支持。Safari 也一致适用。
export default function useViewportHeightVar() {
  useEffect(() => {
    const vv = window.visualViewport;
    const setVar = () => {
      const h = vv ? vv.height : window.innerHeight;
      document.documentElement.style.setProperty('--app-vh', `${h}px`);
      // 键盘进出常伴随残留滚动偏移，一并抹掉，防止收起后错位
      if (window.scrollX !== 0 || window.scrollY !== 0) window.scrollTo(0, 0);
    };
    setVar();
    if (vv) {
      vv.addEventListener('resize', setVar);
      vv.addEventListener('scroll', setVar);
    }
    window.addEventListener('resize', setVar);
    window.addEventListener('orientationchange', setVar);
    return () => {
      if (vv) {
        vv.removeEventListener('resize', setVar);
        vv.removeEventListener('scroll', setVar);
      }
      window.removeEventListener('resize', setVar);
      window.removeEventListener('orientationchange', setVar);
    };
  }, []);
}
